import { createSlice } from "@reduxjs/toolkit";
import { ContactProfile } from "../../types/clients-module-types";
import { CONTACT } from "../../utils/clientsUtils";

type ClientContactProfileState = {
  isLoadingContactInfo: boolean;
  clientContactInfo: ContactProfile;
  actualClientId: number | null;
};

const initialState: ClientContactProfileState = {
  isLoadingContactInfo: true,
  clientContactInfo: CONTACT,
  actualClientId: null,
};

export const clientContactProfileSlice = createSlice({
  name: "clientContactProfile",
  initialState,
  reducers: {
    load: (state, action) => {
      state.actualClientId = action.payload.clientId;
      state.clientContactInfo = action.payload.contactsInfo;
      state.isLoadingContactInfo = false;
    },
    setIsLoadingContactInfo: (state, action) => {
      state.isLoadingContactInfo = action.payload;
    },
    restoreContactProfile: (state) => {
      state.clientContactInfo = CONTACT;
    },
  },
});

// Action creators are generated for each case reducer function
export const { load, setIsLoadingContactInfo, restoreContactProfile } =
  clientContactProfileSlice.actions;

export const IsLoadingContactInfo = (state: any) => {
  return state.clientContactProfile.isLoadingContactInfo;
};

export const SelectClientContactProfile = (state: any) => {
  return state.clientContactProfile.clientContactInfo;
};

export const SelectActualClientId = (state: any) => {
  return state.clientContactProfile.actualClientId;
};

export default clientContactProfileSlice.reducer;
